module.exports = __webpack_public_path__ + "img/swiper3_t.a417e91f.png";